import { Injectable } from '@angular/core';
import { InvocaService } from 'src/app/base/services/invoca.service';
import { Certificado } from '../interfaces/certificado';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class CertificadosService {

  constructor(
    private invoke: InvocaService,
    private sessionService: SessionService
  ) {}

  async obtenerCertificadosUsuario() {
    return this.invoke.httpInvoke('certificados/getCertificadosUsuario');
  }

  async generarCertificado(certificado: Certificado) {
    return this.invoke.httpInvoke('certificados/generarCertificado', certificado);
  }

  async comprobarDisponibilidad(id_certificado: number) {
    return this.invoke.httpInvoke('certificados/comprobarDisponibilidad', {
      id_certificado: id_certificado
    });
  }

  async getCantidadCertificadosAlumno() {
    return this.invoke.httpInvoke('certificados/getCantidadCertificadosAlumno');
  }

  async getCantidadCertificados() {
    return this.invoke.httpInvoke('public/getCantidadCertificados');
  }

}